<template>
  <div>
    <!-- bidirectional data binding（双向数据绑定） -->

    <el-row>
      <el-col class="grid-content" :offset="2" :sm="10" :xs="18">
        <el-input
          placeholder="Search you code here"
          v-model="search"
          class="input-with-select"
          @keyup.native.enter="searchCode"
        >
          <el-button slot="append" icon="el-icon-search" @click="searchCode"></el-button>
        </el-input>
      </el-col>
      
      <el-col :offset='1' :span='4'>
         
          <el-select v-model="limit" placeholder="Page Limit" @change="pageLimitChange">
           <el-option
            :value="4">
          </el-option>
           <el-option
            :value="10">
          </el-option>
          <el-option
            :value="30">
          </el-option>
          <el-option
            :value="50">
          </el-option>
  </el-select>
      </el-col>

      
      <el-col :offset="3" :span="2" :xs="3">
        <el-button type="success" v-on:click="add" size="medium">ADD</el-button>
      </el-col>
    </el-row>
    <div style></div>
    <el-row style="margin-top:10px" v-loading='loading'>
      <el-col>
        <el-collapse v-model="activeNames">
          <el-collapse-item
            v-for="(program,index) in programs"
            :key="program._id"
            :name="program._id"
          >
            <template slot="title">
              <span
                style="font-weight: 800; font-style: initial; font-size: medium;"
              >{{program.title}}</span>
            </template>
            <code-unit
              :program="program"
              :index="index+1"
              @delete="deleteCode"
              :isMobile="isMobile"
            ></code-unit>
          </el-collapse-item>
        </el-collapse>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-sizes="[3, 6, 12]"
          :page-size="limit"
          :pager-count="5"
          layout="prev,pager,next "
          :total="total"
        ></el-pagination>
      </el-col>
    </el-row>
    <!-- <div v-for="(program,index) in programs" :key="program._id">
      <code-unit :program="program" :index="index+1" @delete='deleteCode'></code-unit>
    </div>-->
  </div>
</template>

<script>
// language js
// more codemirror resources
// import 'codemirror/some-resource...'

import CodeUnit from "./CodeUnit";

import api from "@/api";
export default {
  props: ["isMobile"],
  data() {
    return {
      programs: [],
      page: 1,
      limit: 4,
      total: 0,
      search:'',
      loading:false
      //   activeNames: [],
    };
  },
  methods: {
    async searchCode() {
      this.page = 1;
      this.limit = 4;
      this.fethData(this.search);
    },
    async pageLimitChange(value){
      this.page = 1;
      this.limit = value;
      this.fethData(this.search)
    },
    async add() {
      let program = await api.createCode({
        title: "New Javascript Snippet",
        snippet: "console.log('Welcome to tryjsonline')"
      });
      this.page = 1;
      this.limit = 4;
      this.fethData();
      //   this.programs.unshift(program);
    },
    async deleteCode(id) {
      console.log("deletecd");
      await api.deleteCode(id);
      this.fethData();
    },
    async fethData(search) {
      this.loading = true;
      let params = { page: this.page, limit: this.limit };
      if (search) Object.assign(params, { search: this.search });
      let data = await api.getCodes(params);
      //   this.activeNames = [...data.docs].splice(0, 3).map(obj => obj._id);
      this.programs = data.docs;
      this.page = data.page || 1;
      this.limit = data.limit || 4;
      this.total = data.total || 0;
      this.loading = false;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fethData();
      console.log(`current page: ${val}`);
    }
  },
  computed: {
    activeNames() {
      return [...this.programs].splice(0, 3).map(obj => obj._id);
    }
  },
  mounted() {
    console.log("this is current codemirror object", this.codemirror);
    // you can use this.codemirror to do something...
  },
  created() {
    this.fethData();
  },
  components: {
    CodeUnit
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Home.vue